module.exports = __webpack_public_path__ + "img/banner.2705892f.png";